import {SearchOutlined} from '@ant-design/icons'
import {Button, Checkbox, Input, Modal, Select} from 'antd'
import {API_ROOT_URL} from 'envs/_current/config'
import preventDefaultEvent from 'helpers/preventDefaultEvent'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import useDispatchAsyncAction from 'modules/asyncCache/useDispatchAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useToggle} from 'react-use'
import classNames from "classnames";
import {IoChevronDown, IoClose} from "react-icons/io5";
import {renderIf} from "../../Shared";
import {PiFolderSimpleLight} from "react-icons/pi";

export const SelectCategories = ({
                                     type,
                                     selected: externalSelected = [],
                                     onChange,
                                     categoryOptions = [],
                                 }) => {
    const [selected, setSelected] = useState(externalSelected)
    useEffect(() => {
        setSelected(externalSelected)
    }, [externalSelected])
    const entitesRef = useRef({
        ...selected.reduce((result, value) => {
            result[value] = {
                id: value,
                name: value,
            }
            return result
        }, {}),
        ...categoryOptions.reduce((result, value) => {
            result[value.id] = value
            return result
        }, {}),
    })
    const [keyword, setkeyword] = useState('')
    const t = useTranslate()
    const handleChange = (id) => {
        const findIndex = selected.findIndex((item) => item === id)
        let newValues
        if (findIndex > -1) {
            newValues = selected.filter((item, i) => findIndex !== i)
            setSelected(newValues)
            // return onChange(newValues)
        } else {
            newValues = [...selected, id]
            setSelected(newValues)
        }
        // return onChange(newValues)
    }
    const [isToggle, toggle] = useToggle()
    const [{result = [], isLoading}, dispatch] = useDispatchAsyncAction();
    entitesRef.current = {
        ...entitesRef.current,
        ..._.get(result, 'data', []).reduce((result, value) => {
            result[value.id] = value
            return result
        }, {}),
    }
    const options = selected
        .map((id) => {
            const item = entitesRef.current[id]
            if (!item) return null
            return {...item, label: item.name, value: item.id}
        })
        .filter(Boolean)
    const categories = keyword?.length > 0 ? _.get(result, 'data', []) : categoryOptions

    const debouncedispatch = useMemo(() => {
        const handler = (keyword) => {
            setkeyword(keyword)
            dispatch(
                createAsyncAction({
                    apiInfo: {
                        root: API_ROOT_URL,
                        path:
                            '/categories/search?keyword=' +
                            keyword +
                            (type ? `&&type=${type}` : ''),
                        method: 'GET',
                    },
                })
            )
        }
        return _.debounce(handler)
    }, [])

    return (
        <>
            <Select
                options={options}
                open={false}
                onClick={toggle}
                {...{
                    value: selected,
                }}
                mode="multiple"
                placeholder={t('please select')}
                onChange={(value) => {
                    setSelected(value)
                    return onChange(value)
                }}
                style={{width: '100%'}}
                suffixIcon={<IoChevronDown className="text-color-300"/>}
            />
            <Modal
                className="custom-modal"
                style={{padding: 0}}
                destroyOnHidden
                onOk={toggle}
                footer={null}
                open={isToggle}
                onCancel={toggle}
                title={
                    <div
                        className="text-center font-bold text-color-000 uppercase tracking-wide">{t('select categories')}</div>
                }>
                <div className="mx-6 flex flex-col gap-3">
                    <Input
                        autoFocus
                        placeholder={t('please select')}
                        addonAfter={<SearchOutlined/>}
                        onChange={(e) => debouncedispatch(e.target.value)}
                        className="rounded-lg"
                    />
                    {renderIf(
                        options.length > 0,
                        <div className="my-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                            {options.map((item, index) => {
                                // const Icon = _.get(categoryIcons, item.id, categoryIcons['default'])
                                return (
                                    <div key={index}
                                         className="p-2 flex items-center gap-2 shadow hover:shadow-items rounded-md">
                                        <PiFolderSimpleLight size={18}/>
                                        <div className="flex-1 font-medium text-sm text-blue-700 italic">
                                            {item.name}
                                        </div>
                                        <IoClose
                                            size={14}
                                            className="text-color-500 hover:text-primary cursor-pointer"
                                            onClick={() => {
                                                handleChange(item.id)
                                            }}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {(categories || []).map((item, index) => {
                        const {id, name, description} = item
                        const checked = selected.includes(id)
                        // const Icon = _.get(categoryIcons, id, categoryIcons['default'])

                        return (
                            <div
                                key={index}
                                onClick={(e) => {
                                    preventDefaultEvent(e)
                                    handleChange(id)
                                }}
                                className={classNames(
                                    'p-2 flex items-center gap-3 rounded-md cursor-pointer',
                                    checked ? 'border border-primary' : 'custom-render-border hover:shadow'
                                )}>
                                <PiFolderSimpleLight size={30}/>
                                <div className="flex flex-col flex-1">
                                    <div className="font-bold">
                                        {name}
                                    </div>
                                    {!!description && (
                                        <div className="font-bold text-color-300">
                                            {description}
                                        </div>
                                    )}
                                </div>
                                <div className="self-center">
                                    <Checkbox
                                        checked={checked}
                                        value={id}
                                        id={id}
                                        name={id}
                                    />
                                </div>
                            </div>
                        )
                    })}
                    <div className="flex justify-end pt-6">
                        <Button
                            type="primary"
                            className="rounded-lg px-5"
                            onClick={() => {
                                onChange(selected)
                                toggle()
                            }}>
                            {t('save')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
